export default __webpack_public_path__ + "static/media/721_logo_color.d96186d6.svg";